module.exports = __webpack_public_path__ + "img/IMG_2648.cc1b84db.jpg";